import _Object$assign from '@babel/runtime/core-js/object/assign';
import _Number$isFinite from '@babel/runtime/core-js/number/is-finite';
import _typeof from '@babel/runtime/helpers/typeof';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import now from 'performance-now';
import _Object$keys from '@babel/runtime/core-js/object/keys';
import React, { createContext, Component } from 'react';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';

var unlisten = function unlisten(arr, fn) {
  return function () {
    for (var i = arr.length - 1; i > -1; i -= 1) {
      if (arr[i] === fn) {
        arr.splice(i, 1);
      }
    }
  };
};

/* eslint-disable no-underscore-dangle */
var Timer =
/*#__PURE__*/
function () {
  /**
   * @param {{ timeout: number }} settings
   */
  function Timer(settings) {
    var _this = this;

    _classCallCheck(this, Timer);

    this.tick = function () {
      _this.updateState();

      if (_this._timeout > 0) {
        var timeGap = _this._timeout % 1000 || 1000;
        _this._timeout -= timeGap;
        _this._running = _this._timeout <= 0 ? false : _this._running;
        _this._timeoutId = setTimeout(_this.tick, timeGap);
      }
    };

    this.start = function () {
      if (!_this._running) {
        _this._running = true;
        _this._startTime = now();

        _this.tick();
      }
    };

    this.toggle = function () {
      if (_this._running) {
        _this.pause();
      } else if (_this._timeout > 0) {
        _this.start();
      }
    };

    this.toggleReset = function () {
      if (!_this._running && _this._timeout <= 0) {
        _this.reset();
      } else {
        _this.stop();
      }
    };

    this.pause = function () {
      if (_this._running) {
        _this.setTotal(_this._left - (now() - _this._startTime));
      }
    };

    this.stop = function () {
      _this.setTotal(0);
    };

    this.reset = function () {
      _this.setTotal(_this.totalTime);
    };

    this.watches = [];
    this.timeout = NaN;
    this.running = false;
    this.end = false;
    this.beginning = false;
    this.disabled = false;
    this.setup(settings);
  }

  _createClass(Timer, [{
    key: "setup",
    value: function setup(settings) {
      if (!settings || _typeof(settings) !== 'object') {
        throw new Error('setup(settings), settings need to be a object!');
      }

      var timeout = Math.floor(settings.timeout);

      if (!_Number$isFinite(timeout)) {
        throw new Error('setup(settings), settings.timeout need to be a finite number!');
      }

      this.totalTime = timeout;
      this.reset();
    }
  }, {
    key: "setTotal",
    value: function setTotal() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this._timeoutId) clearTimeout(this._timeoutId);
      this._timeoutId = null;
      this._running = false;
      this._timeout = total;
      this._left = total;
      this.updateState();
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var state = {
        timeout: this._timeout,
        running: this._running,
        beginning: this._running && this._timeout === this.totalTime,
        end: this._timeout <= 0,
        disabled: this.totalTime < 0
      };

      _Object$assign(this, state);

      this.watches.forEach(function (fn) {
        return fn(state);
      });
    }
  }, {
    key: "watch",
    value: function watch(fn) {
      if (typeof fn !== 'function') {
        throw Error('fn should be a function');
      }

      this.watches.push(fn);
      return unlisten(this.watches, fn);
    }
  }, {
    key: "destory",
    value: function destory() {
      if (this.watches) {
        this.stop();
        this.watches.splice(0);
        this.watches = null;
      }
    }
  }], [{
    key: "isTimer",
    value: function isTimer(instance) {
      return instance && instance.constructor === this;
    }
  }]);

  return Timer;
}();

/**
 * @param {number|string} second
 * @returns {number} millisecond
 */

function convertSecond(second) {
  var millisecond = Math.floor(second) * 1e3;

  if (!_Number$isFinite(millisecond)) {
    throw Error('sec should be a finite number');
  }

  return millisecond;
}

var TimerController =
/*#__PURE__*/
function () {
  function TimerController(_ref) {
    var _this = this;

    var timeouts = _ref.timeouts,
        resetAllWhenTimeoutsChange = _ref.resetAllWhenTimeoutsChange;

    _classCallCheck(this, TimerController);

    this.registerTimer = function (name, timeout, timers) {
      var _timers = timers || _Object$assign({}, _this.timers);

      _timers[name] = TimerController.createTimer(timeout);

      _this.watchTimer(_timers[name], name, _this._update);

      return _timers;
    };

    this.getContext = function () {
      var timers = _this.timers;

      if (_this.context.timers !== timers) {
        _this.context = _Object$assign({}, _this.context, {
          timers: timers
        });
      }

      return _this.context;
    };

    this.resetTimer = function (name, timeout) {
      _this.timers[name].setup({
        timeout: convertSecond(timeout)
      });
    };

    this.destoryTimer = function (name) {
      if (_this.timers[name]) {
        _this.timers[name].destory();

        delete _this.timers[name];

        _this.unwatchTimer(name);
      }
    };

    this._update = function () {
      if (!_this._stopWatching) {
        _this.setNextTimers();

        _this._callback(_this.getContext());
      }
    };

    /** @type {{[x: string]: function }} */
    this.unwatches = {};
    /** @type {{ [x: string]: TimerLogic }} */

    this.timers = {};
    this.resetAllWhenTimeoutsChange = resetAllWhenTimeoutsChange;

    this._callback = function () {};

    if (timeouts != null) {
      this.hoistedTimeouts = timeouts; // create hoisted timers

      _Object$keys(this.hoistedTimeouts).forEach(function (name) {
        _this.timers[name] = TimerController.createTimer(timeouts[name]);
      });
    }

    this.context = {
      timers: this.timers,
      registerTimer: function registerTimer(name, timeout) {
        if (_this.timers[name]) {
          _this.resetTimer(name, timeout);
        } else {
          _this.timers = _this.registerTimer(name, timeout);
        }

        _this._callback(_this.getContext());
      },
      resetTimer: function resetTimer(name, timeout) {
        _this.resetTimer(name, timeout);

        if (_this.resetAllWhenTimeoutsChange) {
          _Object$keys(_this.timers).forEach(function (k) {
            if (k !== name) {
              _this.timers[k].reset();
            }
          });
        }
      },
      destoryTimer: this.destoryTimer
    };
  }

  _createClass(TimerController, [{
    key: "update",
    value: function update(_ref2) {
      var timeouts = _ref2.timeouts,
          resetAllWhenTimeoutsChange = _ref2.resetAllWhenTimeoutsChange;
      this.resetAllWhenTimeoutsChange = resetAllWhenTimeoutsChange;
      var noop = {};
      var nextTimeouts = timeouts || noop;
      var oldTimeouts = this.hoistedTimeouts || noop;
      /* not changed */

      if (nextTimeouts === oldTimeouts) return null;

      var oldNames = _Object$keys(oldTimeouts);

      var nextNames = _Object$keys(nextTimeouts);

      var equal = oldNames.length === nextNames.length;
      var newTimers = {};

      for (var i = 0; i < nextNames.length; i += 1) {
        var name = nextNames[i];

        if (!(name in oldTimeouts)) {
          this.registerTimer(name, nextTimeouts[name], newTimers);
          equal = false;
        } else if (equal && oldTimeouts[name] !== nextTimeouts[name]) {
          equal = false;
        }
      }

      if (!equal) {
        this.setNextTimers(newTimers);
        this._stopWatching = true;

        for (var _i = 0; _i < oldNames.length; _i += 1) {
          var _name = oldNames[_i];
          var nextTimeout = nextTimeouts[_name];
          var oldTimeout = oldTimeouts[_name];

          if (!(_name in nextTimeouts)) {
            this.destoryTimer(_name);
          } else if (oldTimeout !== nextTimeout) {
            this.resetTimer(_name, nextTimeout);
          } else if (resetAllWhenTimeoutsChange) {
            this.timers[_name].reset();
          }
        }

        this._stopWatching = false;
      }

      this.hoistedTimeouts = nextTimeouts;
      return !equal ? this.getContext() : null;
    }
  }, {
    key: "setNextTimers",
    value: function setNextTimers(newTimers) {
      this.timers = _Object$assign({}, this.timers, newTimers);
      return this.timers;
    }
  }, {
    key: "watchTimer",
    value: function watchTimer(timer, name, fn) {
      this.unwatches[name] = timer.watch(fn);
    }
  }, {
    key: "unwatchTimer",
    value: function unwatchTimer(name) {
      var fn = this.unwatches[name];

      if (typeof fn === 'function') {
        fn();
      }

      delete this.unwatches[name];
    }
    /* a timer's time update */

  }, {
    key: "init",
    value: function init(fn) {
      var _this2 = this;

      this._callback = fn;

      if (this.hoistedTimeouts != null) {
        _Object$keys(this.hoistedTimeouts).forEach(function (name) {
          _this2.watchTimer(_this2.timers[name], name, _this2._update);
        });
      }
    }
  }, {
    key: "destory",
    value: function destory() {
      var _this3 = this;

      this._stopWatching = true;

      _Object$keys(this.timers).forEach(function (name) {
        _this3.destoryTimer(name);
      });

      this._callback = null;
    }
  }], [{
    key: "createTimer",
    value: function createTimer(timeout) {
      return new Timer({
        timeout: convertSecond(timeout)
      });
    }
  }]);

  return TimerController;
}();

var TimerContext = createContext(null);

var Timer$1 =
/*#__PURE__*/
function (_Component) {
  _inherits(Timer, _Component);

  function Timer(props) {
    var _this;

    _classCallCheck(this, Timer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Timer).call(this, props));
    var name = props.name,
        render = props.render;

    if (typeof render !== 'function') {
      throw Error('<Timer>: Prop `render` should be a function');
    }

    if (!name) throw Error('<Timer>: Prop `name` should be provided');
    _this.state = {
      name: name,
      timeout: props.timeout,
      prevProps: _this.props
    };
    return _this;
  }

  _createClass(Timer, [{
    key: "validateTimeout",
    value: function validateTimeout(timeout) {
      var _timeout = Math.floor(timeout);

      if (_Number$isFinite(_timeout)) {
        return _timeout;
      }

      throw Error("<Timer>: Got invalid timeout for timer(".concat(this.state.name, "). \"timeout\" should be a finit number"));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
          timeout = _this$state.timeout,
          name = _this$state.name;

      if (timeout != null) {
        this.context.registerTimer(name, this.validateTimeout(timeout));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var newTimeout = this.state.timeout;
      var prevTimeout = prevState.timeout;

      if (newTimeout !== prevTimeout) {
        this.context.resetTimer(this.state.name, this.validateTimeout(newTimeout));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.timeout != null) {
        this.context.destoryTimer(this.state.name);
      }
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps(timers) {
      var _this$state2 = this.state,
          name = _this$state2.name,
          timeout = _this$state2.timeout;

      if (!timers[name]) {
        if (timeout != null) return null;
        throw Error("<Timer>: Name(".concat(name, ") isn't providered in provider"));
      }

      return {
        timer: timers[name],
        name: name
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(TimerContext.Consumer, null, function (context) {
        _this2.context = context;

        var props = _this2.getRenderProps(context.timers);

        return props ? _this2.props.render(props) : null;
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props !== state.prevProps) {
        if (state.name !== props.name) {
          console.error(Error('<Timer>: Name changing is not supported!'));
        }

        return {
          prevProps: props,
          timeout: state.timeout !== props.timeout ? props.timeout : state.timeout
        };
      }

      return null;
    }
  }]);

  return Timer;
}(Component);

var Scheduler =
/*#__PURE__*/
function (_Component) {
  _inherits(Scheduler, _Component);

  function Scheduler(props, context) {
    var _this;

    _classCallCheck(this, Scheduler);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scheduler).call(this, props, context));
    var render = props.render;

    if (typeof render !== 'function') {
      throw Error('<Scheduler>: Prop `render` should be a function');
    }

    return _this;
  }

  _createClass(Scheduler, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(TimerContext.Consumer, null, function (_ref) {
        var timers = _ref.timers;
        return _this2.props.render({
          timers: timers
        });
      });
    }
  }]);

  return Scheduler;
}(Component);

var TimerProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(TimerProvider, _Component);

  function TimerProvider(props) {
    var _this;

    _classCallCheck(this, TimerProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimerProvider).call(this, props));
    var timeouts = props.timeouts,
        resetAllWhenTimeoutsChange = props.resetAllWhenTimeoutsChange;
    var timerController = new TimerController({
      resetAllWhenTimeoutsChange: resetAllWhenTimeoutsChange,
      timeouts: timeouts
    });
    _this.state = {
      timerController: timerController,
      context: timerController.context,
      prevProps: _this.props
    };
    return _this;
  }

  _createClass(TimerProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var timerController = this.state.timerController;
      timerController.init(function (context) {
        _this2.setState({
          context: context
        });
      });

      if (timerController.context !== this.state.context) {
        this.setState({
          context: timerController.context
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.timerController.destory();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(TimerContext.Provider, {
        value: this.state.context
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props !== state.prevProps) {
        var timerController = state.timerController;
        var timeouts = props.timeouts,
            resetAllWhenTimeoutsChange = props.resetAllWhenTimeoutsChange;
        var context = timerController.update({
          timeouts: timeouts,
          resetAllWhenTimeoutsChange: resetAllWhenTimeoutsChange
        });
        return context ? {
          context: context,
          prevProps: props
        } : {
          prevProps: props
        };
      }

      return null;
    }
  }]);

  return TimerProvider;
}(Component);

TimerProvider.Timer = Timer$1;
TimerProvider.Scheduler = Scheduler;

export { Scheduler, Timer$1 as Timer, TimerProvider };
//# sourceMappingURL=index.m.js.map
